import {CubeSourceBO} from "./CubeSourceBO";
import * as _ from "lodash"
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";

export class CubeSourceBOValidation {

    static async ValidateFields(aBO: CubeSourceBO): Promise<void> {
        const self = this;


    }

    private static addMessage(aBO: CubeSourceBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}